import Loader from "react-loader-spinner";
import "../../Css/MenuWide.css";
import MenuItem from '../MenuItem';
import { Form } from "react-bootstrap";
import { Link } from "react-router-dom";
import ModalSendSMS from "../Modals/ModalSendSMS";
import ModalCommands from "../Modals/ModalCommands";
import ModalReminder from "../Modals/ModalReminder";
import ModalNewNotice from "../Modals/ModalNewNotice";
import { useDispatch, useSelector } from "react-redux";
import { Fragment, useCallback, useState } from "react";
import { logOut } from "../../BaseInfo/store/api/Users";
import ModalAddQuickAccess from "../Modals/ModalAddQuickAccess";
import ModalImportFromExcel from "../../Pages/ModalImportFromExcel";
import ModalSearchReminders from "../../Pages/ModalSearchReminders";
import { unsubscribePushManager } from "../PushNotificationManager";
import ModalDocumentCover from "../../Accounting/Components/ModalDocumentCover";
import { addNewCustomers, addNewPreCustomers } from "../../CRM/store/api/CustomerApi";
import ModalPermanetDocuments from "../../Accounting/Components/ModalPermanetDocuments";
import { invoiceTypes, networkRelease, setErrorDialog, checkModule, systemModules, activeSerial, getCurrentDurationName, chequeStatuses, bomTypes } from "../../store/api/CommonFunctions";


import {
  UiChecksGrid, InfoSquare, House, Power, PersonCircle, HouseDoor, CalendarDate, Calendar2Date, FileEarmarkRuled, FileEarmarkRuledFill,
  FileEarmarkText, FileEarmarkTextFill, FileEarmarkPost, FilePostFill, FilePost, FileSpreadsheet, FileSpreadsheetFill, Search, Tools, Stickies,
  LayoutTextWindow, Files, Command, ChatRight, PersonBadge, PersonPlus, FileEarmarkExcelFill, CalendarEventFill, Gear, PersonSquare,
  BoxArrowDown, BoxSeam, MenuButton, Person, GearWideConnected, Envelope, EnvelopeFill, Grid3x3GapFill, GridFill, Grid1x2Fill, BookFill, BookHalf, Book,
  Coin, ChatRightText, CardText, JournalText, PersonPlusFill, JournalAlbum, HddNetwork, Toggle2On, Phone, Globe, Newspaper, FileEarmarkPostFill, List, ShieldCheck, Calendar2, CreditCard, CashCoin, Bank, Bank2, CardList, Bug, Diagram2Fill, Diagram3Fill, ColumnsGap, Truck, CreditCard2Front, CreditCard2FrontFill, CreditCard2Back, CreditCardFill, Headset, EmojiAngry, BoundingBox, Speedometer, LayoutWtf, Columns, Check2Square, Building, CartDash, CashStack, PersonLinesFill, HouseDoorFill, ClipboardData, Basket2, EnvelopeCheck, EnvelopePaper, EnvelopeExclamation, EnvelopeAt, EnvelopePlus, Calculator, FileEarmarkBarGraph, FileEarmarkBarGraphFill,
  Toggles2,
  PencilSquare,
  SortNumericDown,
  Upc,
  ClockHistory,
  GeoAlt,
  MenuButtonWide,
  PersonGear,
  Box2,
  PersonRolodex,
  FileEarmarkDiff,
  FileEarmarkSpreadsheet,
  Clipboard2CheckFill,
  Clipboard2Data,
  Clipboard2DataFill,
  Calendar2Event
} from 'react-bootstrap-icons';
import ModalDuration from "../Modals/ModalDuration";
import ModalAddNewPOS from "../../Accounting/Components/ModalAddNewPOS";
import ModalSpecialDocuments from "../../Accounting/Components/ModalSpecialDocuments";
import ModalDefinedServiceCosts from "../../Services/Components/ModalDefinedServiceCosts";
import ModalProductBugs from "../../Services/Components/ModalProductBugs";
import ModalAddEditCustomerGroups from "../../CRM/Components/ModalAddEditCustomerGroups";
import ModalBaseInfo from "../../BaseInfo/Components/ModalBaseInfo";
import ModalAddEditChequeFunctions from "../../Accounting/Components/ModalAddEditChequeFunctions";
import ModalBankAccounts from "../../Accounting/Components/ModalBankAccounts";
import ModalChequeBook from "../../Accounting/Components/ModalChequeBook";
import { useHistory } from "react-router-dom";
import ModalAddEditComplaintsGroup from "../../CRM/Components/ModalAddEditComplaintsGroup";
import ModalAddEditComplaintStatus from "../../CRM/Components/ModalAddEditComplaintStatus";
import ModalAddEditComplaintType from "../../CRM/Components/ModalAddEditComplaintType";
import ModalAddEditComplaintTarget from "../../CRM/Components/ModalAddEditComplaintTarget";
import ModalActiveGuaranteeCard from "../../Services/Components/ModalActiveGuaranteeCard";
import ModalStorageManagement from "../../BaseInfo/Components/ModalStorageManagement";
import ModalPreCustomerJob from "../../CRM/Components/ModalPreCustomerJob";
import ModalProductAccessories from "../../Services/Components/ModalProductAccessories";
import ModalSelectPerson from "../Modals/ModalSelectPerson";
import ModalGuaranteeHolders from "../../BaseInfo/Components/ModalGuaranteeHolders";
import ModalServiceStatusManagement from "../../Services/Components/Tasks/ModalServiceStatusManagement";
import ModalProductTypes from "../../BaseInfo/Components/ModalProductTypes";
import { rewriteAllInvoices } from "../../Sale/store/api/Invoice";
import ModalMergeDocuments from "../../Accounting/Components/ModalMergeDocuments";
import ModalSortDocuments from "../../Accounting/Components/ModalSortDocuments";
import ModalBarcodePrint from "../../BaseInfo/Components/ModalBarcodePrint";
import { addNewProducts } from "../../BaseInfo/store/api/GetAllProduct";
import ModalAddEditLocation from "../../BaseInfo/Components/ModalAddEditLocation";
import ModalUserRelations from "../../Office/Components/ModalUserRelations";
import ModalSaleCompatitors from "../../CRM/Components/ModalSaleCompatitors";
import ModalBoMStatus from "../../Production/Components/ModalBoMStatus";
import ModalUpdateProductsPrice from "../../BaseInfo/Components/ModalUpdateProductsPrice";
import ModalSaveServiceBatch from "../../Services/Components/Tasks/ModalSaveServiceBatch";
import ModalAssignProductToGuaranteeCards from "../../Services/Components/Tasks/ModalAssignProductToGuaranteeCards";
const pkg = require('../../../package.json');
const MenuWide = (props) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const [modalSpecialDoc, setModalSpecialDoc] = useState({ show: false });
  const [modalPos, setModalPos] = useState({ show: false });
  const [modalDuration, setModalDuration] = useState({ show: false })
  const { menuWidth, setMenuWidth, setModalAboutUs, menuName, setQAList } = props;
  const company = JSON.parse(localStorage.getItem("Company"));
  const userInfo = JSON.parse(localStorage.getItem("UserInfo"));
  const [exlModalInfo, setExlModalInfo] = useState(null);
  const [modalSMS, setModalSMS] = useState({ show: false });
  const [modalPermanetDocs, setModalPermanetDocs] = useState({ show: false });
  const [showImportExl, setShowImportExl] = useState(false);
  const [popCommand, setPopCommand] = useState({ show: false });
  const [popReminder, setPopReminder] = useState({ show: false });
  const [showSearchReminderModal, setShowSearchReminderModal] = useState(false);
  const [modalNoticeData, setModalNoticeData] = useState({ show: false });
  const [modalQAccess, setModalQAccess] = useState({ show: false });
  const [modalDoccover, setModalDocCover] = useState({ show: false });
  const [modalDefined, setModalDefined] = useState({ show: false });
  const [modalProductBugs, setModalProductBugs] = useState({ show: false });
  const [modalCustomerGroups, setModalCustomerGroups] = useState({ show: false });
  const [modalBaseInfo, setModalBaseInfo] = useState({ show: false });
  const [modalChequeFunction, setModalChequeFunction] = useState({ Show: false });
  const [modalBankAcc, setModalBankAcc] = useState({ Show: false });
  const [modalChequeBook, setModalChequeBook] = useState({ Show: false });
  const [modalComplaintsGroup, setModalComplaintsGroup] = useState({ show: false });
  const [modalComplainsStatus, setModalComplaintsStatus] = useState({ show: false });
  const [modalCompType, setModalCompType] = useState({ show: false });
  const [modalCompTarget, setModalCompTarget] = useState({ show: false });
  const [modalActiveCard, setModalActiveCard] = useState({ show: false });
  const [modalStgManagement, setModalstgManagement] = useState({ show: false });
  const [modalPreCustJob, setModalPreCustJob] = useState({ show: false });
  const [modalPA, setModalPA] = useState({ show: false });
  const [modalPerson, setModalPerson] = useState({ show: false });
  const [modalGHolders, setModalGHolders] = useState({ show: false });
  const [modalSSM, setModalSSM] = useState(false);
  const [modalPT, setModalPT] = useState({ show: false });
  const [modalMergeDocs, setModalMergeDocs] = useState({ show: false });
  const [modalSortDocs, setModalSortDocs] = useState({ show: false });
  const [modalBarcodePrint, setModalBarcodePrint] = useState({ show: false });
  const [rewritePending, setRewritePending] = useState(false);
  const [modalAddEditLoc, setModalAddEditLoc] = useState({ show: false });
  const [modalUserRelations, setModalUserRelations] = useState({ show: false });
  const [modalSaleComps, setModalSaleComps] = useState({ show: false });
  const [modalBoMStatus, setModalBoMStatus] = useState({ show: false });
  const [modalUpdatePPrice, setModalUpdatePPrice] = useState({ show: false });
  const [modalSaveService, setModalSaveService] = useState({ show: false });
  const [modalAssignP2GC, setModalAssignP2GC] = useState({ show: false });
  const { activeSS, appModules } = useSelector(state => { return { activeSS: state.SystemSettingsReducer.activeSubsystems?.Data || {}, appModules: state.SystemSettingsReducer.appModules?.Data } });
  const showSearchReminders = (e) => {
    if (e.target.tagName !== "SPAN") {
      return;
    }
    setShowSearchReminderModal(true);
    setMenuWidth(0);
  }
  const closeMenu = () => {
    setMenuWidth(0);
  }
  const showReminderModal = (e) => {
    if (e.target.tagName !== "SPAN") {
      return;
    }
    setPopReminder({ show: true });
    setMenuWidth(0);
  }
  const subSystemHome = useCallback((name) => {
    if(name === "Main")
    {
      return "/";
    }
    if (name?.length > 0) {
      return `/${name}`;
    }
    else {
      return window.location.pathname;
    }
    // switch (name) {

    //   case "Services":
    //     return "/Services";
    //   case "Sale":
    //     return "/Sale";
    //   case "Accounting":
    //     return "/Accounting";
    //   case "CRM":
    //     return "/CRM";
    //   default:
    //     return "/";
    // }
  });
  const preCustomerFields = [
    { DatabaseName: "Name", DisplayName: "نام" },
    { DatabaseName: "Phone", DisplayName: "تلفن" },
    { DatabaseName: "Fax", DisplayName: "فکس" },
    { DatabaseName: "Mobile", DisplayName: "همراه" },
    { DatabaseName: "Email", DisplayName: "Email" },
    { DatabaseName: "NationalCode", DisplayName: "شماره ملی" },
    { DatabaseName: "Address", DisplayName: "آدرس" },
    { DatabaseName: "Description", DisplayName: "توضیحات" },
    { DatabaseName: "JobStr", DisplayName: "رسته شغلی" },
    { DatabaseName: "Axt1", DisplayName: "مشخصه یک" },
    { DatabaseName: "Axt2", DisplayName: "مشخصه دو" },
    { DatabaseName: "Axt3", DisplayName: "مشخصه سه" },
    { DatabaseName: "Axt4", DisplayName: "مشخصه چهار" },
    { DatabaseName: "Axt5", DisplayName: "مشخصه پنج" },
    { DatabaseName: "Axt6", DisplayName: "مشخصه شش" },
    { DatabaseName: "Axt7", DisplayName: "مشخصه هفت" },
    { DatabaseName: "Axt8", DisplayName: "مشخصه هشت" },
    { DatabaseName: "Axt9", DisplayName: "مشخصه نه" },
    { DatabaseName: "Axt10", DisplayName: "مشخصه ده" },
    { DatabaseName: "HowToNowStr", DisplayName: "نحوه آشنایی" },
    { DatabaseName: "CityName", DisplayName: "شهر" },
    { DatabaseName: "ProvinceName", DisplayName: "استان" },
  ]
  const customerFields = [
    { DatabaseName: "Name", DisplayName: "نام" },
    { DatabaseName: "Phone", DisplayName: "تلفن" },
    { DatabaseName: "Fax", DisplayName: "فکس" },
    { DatabaseName: "Mobile", DisplayName: "همراه" },
    { DatabaseName: "Email", DisplayName: "Email" },
    { DatabaseName: "NationalCode", DisplayName: "شماره ملی" },
    { DatabaseName: "Address", DisplayName: "آدرس" },
    { DatabaseName: "Description", DisplayName: "توضیحات" },
    { DatabaseName: "Job", DisplayName: "رسته شغلی" },
    { DatabaseName: "Axt1", DisplayName: "مشخصه یک" },
    { DatabaseName: "Axt2", DisplayName: "مشخصه دو" },
    { DatabaseName: "Axt3", DisplayName: "مشخصه سه" },
    { DatabaseName: "Axt4", DisplayName: "مشخصه چهار" },
    { DatabaseName: "Axt5", DisplayName: "مشخصه پنج" },
    { DatabaseName: "Axt6", DisplayName: "مشخصه شش" },
    { DatabaseName: "Axt7", DisplayName: "مشخصه هفت" },
    { DatabaseName: "Axt8", DisplayName: "مشخصه هشت" },
    { DatabaseName: "Axt9", DisplayName: "مشخصه نه" },
    { DatabaseName: "Axt10", DisplayName: "مشخصه ده" },
    { DatabaseName: "City", DisplayName: "شهر" },
    { DatabaseName: "Province", DisplayName: "استان" },
  ]
  const productFields = [
    { DatabaseName: "BarCode", DisplayName: "بارکد" },
    { DatabaseName: "ExtAttr1", DisplayName: "مشخصه یک" },
    { DatabaseName: "ExtAttr2", DisplayName: "مشخصه دو" },
    { DatabaseName: "GauranteeSalePrice", DisplayName: "قیمت گارانتی" },
    { DatabaseName: "HolderName", DisplayName: "نام برند" },
    { DatabaseName: "IDForTaxOffice", DisplayName: "شناسه مالیاتی" },
    { DatabaseName: "Manufacturer", DisplayName: "تولید کننده" },
    { DatabaseName: "Model", DisplayName: "مدل" },
    { DatabaseName: "Name", DisplayName: "نام/نوع" },
    { DatabaseName: "ProductOrPart", DisplayName: "قطعه" },
    { DatabaseName: "PurchasePrice", DisplayName: "قیمت خرید" },
    { DatabaseName: "SalePrice", DisplayName: "قیمت فروش" },
    { DatabaseName: "SalePrice3", DisplayName: "قیمت فروش سوم" },
    { DatabaseName: "GroupCode", DisplayName: "کد گروه" },
    { DatabaseName: "MainGroupCode", DisplayName: "کد گروه اصلی" }

  ]
  const addPrecustomers = useCallback((data, updateFoundItems) => {
    dispatch(addNewPreCustomers(data, updateFoundItems));
  });
  const addCustomers = useCallback((data, updateFoundItems) => {
    dispatch(addNewCustomers(data, updateFoundItems));
  });
  const addProducts = useCallback((data) => {
    const onAdd = (res) => {
      if (res.Error) {
        setErrorDialog(dispatch, res.Error, "دریافت کالا از اکسل");
      }
      else {
        setErrorDialog(dispatch, "success", "دریافت کالاها از اکسل");
      }

    }
    addNewProducts(data, onAdd);
  });
  const showModalImportExl = useCallback((type) => {
    const modalInfo = {};
    if (type === "precustomer") {
      modalInfo.formName = "PreCustomer";
      modalInfo.submitData = addPrecustomers;
      modalInfo.pageFields = preCustomerFields.sort((a, b) => (a.DisplayName > b.DisplayName) ? 1 : (a.DisplayName < b.DisplayName ? -1 : 0));
    }
    else if (type === "customer") {
      modalInfo.formName = "Customer";
      modalInfo.submitData = addCustomers;
      modalInfo.pageFields = customerFields.sort((a, b) => (a.DisplayName > b.DisplayName) ? 1 : (a.DisplayName < b.DisplayName ? -1 : 0));
    }
    else if (type === "product") {
      modalInfo.formName = "Product";
      modalInfo.submitData = addProducts;
      modalInfo.pageFields = productFields.sort((a, b) => (a.DisplayName > b.DisplayName) ? 1 : (a.DisplayName < b.DisplayName ? -1 : 0));
    }
    setExlModalInfo(modalInfo);
    setShowImportExl(true);
    setMenuWidth(0);
  });
  const showModalSMS = useCallback((e) => {
    if (e.target.tagName !== "SPAN") {
      return;
    }
    setModalSMS({
      show: true
    })
    setMenuWidth(0);

  });
  const showModalDefined = useCallback((e) => {
    if (e.target.tagName !== "SPAN") {
      return;
    }
    setMenuWidth(0);
    setModalDefined({
      show: true
    })
  });
  const showModalProductBugs = useCallback((e) => {
    if (e.target.tagName !== "SPAN") {
      return;
    }
    setMenuWidth(0);
    setModalProductBugs({
      show: true
    })
  });
  const showModalNotice = useCallback((e) => {
    if (e.target.tagName === "svg") {
      return;
    }
    setModalNoticeData({
      show: true
    })
    setMenuWidth(0);
  });
  const showModalDocumentCover = useCallback((e) => {
    if (e.target.tagName !== "SPAN") {
      return;
    }
    setMenuWidth(0);
    setModalDocCover({
      show: true
    })
  })
  const showModalElectronicAccBook = useCallback((e) => {
    if (e.target.tagName !== "SPAN") {
      return;
    }
    setMenuWidth(0);
    setModalDocCover({
      show: true,
      isElectoricAccBook: true
    })
  })
  const showModalPermanetDocs = useCallback((e) => {
    if (e.target.tagName === "svg") {
      return;
    }
    setMenuWidth(0);
    setModalPermanetDocs({
      show: true
    })
  })
  const showCommand = useCallback((e) => {
    if (e.target.tagName !== "SPAN") {
      return;
    }
    setMenuWidth(0);
    setPopCommand({
      show: true
    })
  });
  const findMenu = useCallback((txt) => {
    const menuContainer = document.querySelector("div.sidenav");
    if ((txt ?? "") === "") {
      for (let div of menuContainer.querySelectorAll('div.menuItem')) {
        div.style.display = "block";
        div.classList.remove("openedMenu");
      }
      for (let menuLeaf of menuContainer.querySelectorAll("a.menuLeaf")) {
        menuLeaf.style.display = "block";
      }
      return;
    }
    for (let div of menuContainer.querySelectorAll('div.menuItem')) {
      div.style.display = "none";
      div.classList.remove("openedMenu");
    }

    for (let m of menuContainer.querySelectorAll('div.menuItem')) {
      if (!m.textContent.includes(txt)) {
        continue;
      }
      for (let menuLeaf of m.querySelectorAll("a.menuLeaf")) {
        if (!menuLeaf.textContent.includes(txt)) {
          menuLeaf.style.display = "none";
        }
      }
      m.style.display = "block";
      m.classList.add("openedMenu");
    }
  });
  const menuIconClick = useCallback((e) => {
    let svg = e.target;
    if (svg.tagName === "path") {
      svg = svg.parentNode;
    }
    let tagA = svg.parentNode;

    if (tagA.tagName !== "A") {
      tagA = tagA.parentNode;
    }
    e.preventDefault();
    setModalQAccess({
      show: true,
      pageUrl: tagA.pathname,
      accessTitle: tagA.querySelector("span").textContent,
      subSystem: tagA.pathname.split("/")[1],
      icon: svg,
      setQAList: setQAList
    })
  });
  const releaseNet = useCallback((e) => {
    if (e.target.tagName !== "SPAN") {
      return;
    }
    const onSucess = (res) => {
      if (res.Error) {
        setErrorDialog(dispatch, res.Error, "آزادسازی شبکه");
      }
      else if (res?.toLowerCase() === "success") {
        setErrorDialog(dispatch, "success", "آزادسازی شبکه");
        window.location.reload();
      }
    }
    networkRelease(onSucess);
  });
  const activeSoftware = useCallback((e) => {

    if (e.target.tagName !== "SPAN") {
      return;
    }
    const onSuccess = (res) => {
      if (res.Error) {
        setErrorDialog(dispatch, res.Error, "فعالسازی نرم افزار");
      }
      else if (res?.toLowerCase() !== "pending") {
        setErrorDialog(dispatch, res, "فعالسازی نرم افزار");
      }
    }
    activeSerial(onSuccess);
  });
  const showModalDuration = useCallback((e) => {
    if (e.target.tagName !== "SPAN") {
      return;
    }
    setModalDuration({ show: true });
  });
  const showModalPos = useCallback((e) => {
    if (e.target.tagName === "svg") {
      return;
    }
    closeMenu();
    setModalPos({ show: true });
  });
  const showModalSpecialDocuments = useCallback((e, docType) => {
    if (e.target.tagName === "svg") {
      return;
    }
    setMenuWidth(0);
    setModalSpecialDoc({
      show: true,
      type: docType
    })
  });
  const showModalCustomerGroups = useCallback((e) => {
    if (e.target.tagName !== "SPAN") {
      return;
    }
    setModalCustomerGroups({
      show: true
    })
  });
  const showModalBaseInfo = useCallback((e) => {
    if (e.target.tagName !== "SPAN") {
      return;
    }
    setModalBaseInfo({
      show: true
    })
    setMenuWidth(0);
  });
  const showModalChequeFunction = useCallback((e, chequeStatus, mixed) => {
    if (e.target.tagName !== "SPAN") {
      return;
    }
    setModalChequeFunction({
      Show: true,
      ChequeStatus: chequeStatus,
      Mixed: mixed
    })
    setMenuWidth(0);
  });
  const showModalBankAcc = useCallback((e) => {
    if (e.target.tagName === "svg") {
      return;
    }
    setModalBankAcc({
      Show: true,
      ForSelect: false
    })
    setMenuWidth(0);
  });
  const showModalChequeBook = useCallback((e) => {
    if (e.target.tagName === "svg") {
      return;
    }
    setModalChequeBook({
      Show: true
    });
    setMenuWidth(0);
  });
  const showUserDashboard = useCallback(() => {
    history.push("/UserDashboard");
    setMenuWidth(0);
  });
  const showModalComplaintsGroup = useCallback((e) => {
    if (e.target.tagName !== "SPAN") {
      return;
    }
    setModalComplaintsGroup({
      show: true
    })
    closeMenu();
  });
  const showModalCompType = useCallback((e) => {
    if (e.target.tagName !== "SPAN") {
      return;
    }
    setModalCompType({
      show: true
    })
  });
  const showModalComplaintsStatus = useCallback((e) => {
    if (e.target.tagName !== "SPAN") {
      return;
    }
    setModalComplaintsStatus({
      show: true
    })
    closeMenu();
  })
  const showModalCompTarget = useCallback((e) => {
    if (e.target.tagName !== "SPAN") {
      return;
    }
    setModalCompTarget({ show: true });
  });
  const showModalActiveCard = useCallback((e) => {
    if (e.target.tagName !== "SPAN") {
      return;
    }
    setModalActiveCard({ show: true });
    setMenuWidth(0);
  });
  const showModalStgManagement = useCallback((e) => {
    if (e.target.tagName !== "SPAN") {
      return;
    }
    setModalstgManagement({
      show: true
    })
    closeMenu();
  });
  const showModalPreCustJob = useCallback((e) => {
    if (e.target.tagName !== "SPAN") {
      return;
    }
    setModalPreCustJob({
      show: true
    });
    closeMenu();
  });
  const showModalPA = useCallback((e) => {
    if (e.target.tagName !== "SPAN") {
      return;
    }
    setModalPA({ show: true });
    closeMenu();
  });
  const showModalSSM = useCallback((e) => {
    if (e.target.tagName !== "SPAN") {
      return;
    }
    setModalSSM(true);
    closeMenu();
  });
  const showModalPerson = useCallback((e) => {
    if (e.target.tagName !== "SPAN") {
      return;
    }
    const onSelect = (p) => {
      if (p?.PersonType) {
        const type = p.PersonType.toLowerCase();
        const id = p.ID;

        const urlMap = {
          precustomer: `/CRM/AddEditPreCustomer/${id}`,
          customer: `/CRM/AddEditCustomer/${id}`,
          agent: `/Services/AddEditStaff/true/${id}`,
        };

        const url = urlMap[type] || `/Services/AddEditStaff/false/${id}`;
        window.open(url);
      }
    }
    closeMenu()
    setModalPerson({
      show: true,
      onSelect: onSelect
    })
  });
  const showModalGHolders = useCallback((e) => {
    if (e.target.tagName !== "SPAN") {
      return;
    }
    setModalGHolders({
      show: true
    })
    setMenuWidth(0);
  });
  const showModalMergeDocs = useCallback((e) => {
    if (e.target.tagName === "svg") {
      return;
    }
    setModalMergeDocs({ show: true });
  });
  const showModalSortDocs = useCallback((e) => {
    if (e.target.tagName === "svg") {
      return;
    }
    setModalSortDocs({ show: true });
  });
  const showModalBarcodePrint = useCallback((e) => {
    if (e.target.tagName !== "SPAN") {
      return;
    }
    setModalBarcodePrint({ show: true });
  });
  const rewriteInvoice = useCallback((e) => {
    if (e.target.tagName !== "SPAN") {
      return;
    }
    if (rewritePending) {
      return;
    }
    setRewritePending(true);
    const onRewrite = (res) => {

      if (res.Data) {
        setErrorDialog(dispatch, "success", "بازنویسی فاکتورها");
        setRewritePending(false);
      }
      else if (res.Error) {
        setErrorDialog(dispatch, res.Error, "بازنویسی فاکتورها");
        setRewritePending(false);
      }
    }
    rewriteAllInvoices(onRewrite);
    closeMenu();
  });
  const showModalUserRelations = useCallback((e) => {
    if (e.target.tagName !== "SPAN") {
      return;
    }
    setModalUserRelations({ show: true });
    closeMenu();
  })
  const showModalProductType = useCallback((e) => {
    if (e.target.tagName !== "SPAN") {
      return;
    }
    setModalPT({ show: true });
    closeMenu();
  });
  const showModalLocation = useCallback((e) => {
    if (e.target.tagName !== "SPAN") {
      return;
    }
    setModalAddEditLoc({ show: true });
  });
  const showModalBoMStaus = useCallback(e => {
    if (e.target.tagName !== "SPAN") {
      return;
    }
    setModalBoMStatus({ show: true });
    closeMenu();
  })
  const showModalSaleComps = useCallback((e) => {
    if (e.target.tagName !== "SPAN") {
      return;
    }
    setModalSaleComps({
      show: true
    });
    closeMenu();
  });
  const showModalUpdateProductPrice = useCallback((e) => {
    if (e.target.tagName !== "SPAN") {
      return;
    }
    setModalUpdatePPrice({
      show: true
    });
    closeMenu();
  });
  const showModalSaveSerive = useCallback((e) => {
    if (e.target.tagName !== "SPAN") {
      return;
    }
    setModalSaveService({
      show: true
    });
    closeMenu();
  });
  const showModalAssignP2GC = useCallback((e) => {
    if (e.target.tagName !== "SPAN") {
      return;
    }
    setModalAssignP2GC({ show: true });
    closeMenu();
  });
  const logOutUser = async () => {
    await unsubscribePushManager();
    logOut();
    window.location.replace("/");
  }
  return (
    activeSS ?
      <Fragment>
        <ModalSendSMS popData={modalSMS} setPopData={setModalSMS} />
        <ModalReminder pop={popReminder} setPop={setPopReminder} />
        <ModalCommands popData={popCommand} setPopData={setPopCommand} />
        <ModalSearchReminders showModal={showSearchReminderModal} setShow={setShowSearchReminderModal} setPopReminder={setPopReminder} />
        <ModalNewNotice popData={modalNoticeData} setPopData={setModalNoticeData} />
        <ModalAddQuickAccess popData={modalQAccess} setPopData={setModalQAccess} />
        <ModalDocumentCover popData={modalDoccover} setPopData={setModalDocCover} />
        <ModalPermanetDocuments popData={modalPermanetDocs} setPopData={setModalPermanetDocs} />
        <ModalDuration popData={modalDuration} setPopData={setModalDuration} />
        <ModalAddNewPOS popData={modalPos} setPopData={setModalPos} />
        <ModalSpecialDocuments popData={modalSpecialDoc} setPopData={setModalSpecialDoc} />
        <ModalDefinedServiceCosts popData={modalDefined} setPopData={setModalDefined} />
        <ModalProductBugs popData={modalProductBugs} setPopData={setModalProductBugs} />
        <ModalAddEditCustomerGroups popData={modalCustomerGroups} setPopData={setModalCustomerGroups} />
        <ModalBaseInfo popData={modalBaseInfo} setPopData={setModalBaseInfo} />
        <ModalAddEditChequeFunctions popData={modalChequeFunction} setPopData={setModalChequeFunction} />
        <ModalBankAccounts popData={modalBankAcc} setPopData={setModalBankAcc} />
        <ModalChequeBook popData={modalChequeBook} setPopData={setModalChequeBook} />
        <ModalAddEditComplaintsGroup popData={modalComplaintsGroup} setPopData={setModalComplaintsGroup} />
        <ModalAddEditComplaintStatus popData={modalComplainsStatus} setPopData={setModalComplaintsStatus} />
        <ModalAddEditComplaintType popData={modalCompType} setPopData={setModalCompType} />
        <ModalAddEditComplaintTarget popData={modalCompTarget} setPopData={setModalCompTarget} />
        <ModalActiveGuaranteeCard popData={modalActiveCard} setPopData={setModalActiveCard} />
        <ModalStorageManagement popData={modalStgManagement} setPopData={setModalstgManagement} />
        <ModalPreCustomerJob popData={modalPreCustJob} setPopData={setModalPreCustJob} />
        <ModalProductAccessories popData={modalPA} setPopData={setModalPA} />
        <ModalSelectPerson popData={modalPerson} setPopData={setModalPerson} />
        <ModalGuaranteeHolders popData={modalGHolders} setPopData={setModalGHolders} />
        <ModalServiceStatusManagement show={modalSSM} close={() => setModalSSM(false)} />
        <ModalProductTypes popData={modalPT} setPopData={setModalPT} />
        <ModalMergeDocuments popData={modalMergeDocs} setPopData={setModalMergeDocs} />
        <ModalSortDocuments popData={modalSortDocs} setPopData={setModalSortDocs} />
        <ModalBarcodePrint popData={modalBarcodePrint} setPopData={setModalBarcodePrint} />
        <ModalAddEditLocation popData={modalAddEditLoc} setPopData={setModalAddEditLoc} />
        <ModalUserRelations popData={modalUserRelations} setPopData={setModalUserRelations} />
        <ModalBoMStatus popData={modalBoMStatus} setPopData={setModalBoMStatus} />
        <ModalSaleCompatitors popData={modalSaleComps} setPopData={setModalSaleComps} />
        <ModalUpdateProductsPrice popData={modalUpdatePPrice} setPopData={setModalUpdatePPrice} />
        <ModalSaveServiceBatch popData={modalSaveService} setPopData={setModalSaveService} />
        <ModalAssignProductToGuaranteeCards popData={modalAssignP2GC} setPopData={setModalAssignP2GC} />
        <div style={{ width: menuWidth }} className="sidenav">
          {exlModalInfo &&
            <ModalImportFromExcel show={showImportExl} setShow={setShowImportExl}
              submitData={exlModalInfo.submitData}
              pageFields={exlModalInfo.pageFields}
              formName={exlModalInfo.formName} />
          }
          <div className="hoverIcon" style={{ position: "absolute", top: "0", right: "20px", cursor: "pointer" }} onClick={showUserDashboard}>
            <PersonCircle size={22} color="rgb(115, 57, 141)" style={{ float: "right", marginTop: "13px" }} />
            {<span style={{ float: "right", marginTop: "15px", marginRight: "5px", color: "rgb(115, 57, 141)", textAlign: "right", maxWidth: "120px", maxHeight: "20px", overflow: "hidden" }}>{userInfo?.Name}</span>}
          </div>
          <p className="closebtn" style={{ cursor: "pointer" }} onClick={closeMenu}>&times;</p>
          <Link to={subSystemHome(menuName)} title="صفحه اصلی" onClick={closeMenu} className="homeBtn">
            <House style={{ color: 'green' }} size={22} />
          </Link>

          <a href={menuName === "Main" ? "#" : "/"} onClick={closeMenu} className="homeHomeBtn" >
            <HouseDoor title="منوی اصلی" style={{ color: menuName === "Main" ? 'gray' : "'#3c00ff'" }} size={22} />
          </a>
          <a /*href='/'*/ onClick={logOutUser} className="logoutBtn">
            <Power style={{ color: 'red' }} size={22} />
          </a>
          <div style={{ display: menuWidth !== "0" ? "block" : "none" }}>
            {menuName === "Main" &&
              <div className="mb-1">
                <Form.Control style={{ width: "85%", margin: "auto", height: "30px", fontSize: "13px" }} placeholder="جستجوی منو" onChange={e => findMenu(e.target.value)} />
              </div>
            }
            {(menuName === "Main" || menuName === "BaseInfo") && checkModule(appModules, systemModules.BaseInfo) &&
              <MenuItem title="اطلاعات پایه" className={menuName === "BaseInfo" ? "openedMenu" : ""} subsysCode={2} items={[
                {
                  type: "menuItem", title: "تنظیمات و اطلاعات پایه", subItems: [
                    { type: "link", to: "/BaseInfo/SystemSettings", onClick: closeMenu, text: "ویرایش تنظیمات", code: 2, icon: <Gear style={{ marginTop: "2px", color: 'blue' }} size={15} onClick={menuIconClick} /> },
                    { type: "link", to: "", onClick: showModalBaseInfo, text: "اطلاعات پایه", code: 4, icon: <ColumnsGap style={{ marginTop: "2px", color: 'red' }} size={15} onClick={menuIconClick} /> },
                    { type: "link", to: "", onClick: showModalLocation, text: "مناطق جغرافیایی", code: 8, icon: <GeoAlt style={{ marginTop: "2px", color: 'green' }} size={15} onClick={menuIconClick} /> },

                  ]
                },
                {
                  type: "menuItem", title: "مشتریان", showCondition: () => !checkModule(appModules, systemModules.CRM), subItems: [
                    { type: "a", href: "/BaseInfo/AddEditCustomer/0", onClick: closeMenu, text: "مشتری جدید", code: 16, icon: <PersonSquare style={{ marginTop: "2px", color: '#0b8e95' }} size={15} onClick={menuIconClick} /> },
                    { type: "link", to: "/BaseInfo/SearchCustomer", onClick: closeMenu, text: "جستجوی مشتریان", code: 32, icon: <Search style={{ marginTop: "2px", color: 'violate' }} size={15} onClick={menuIconClick} /> }
                  ]
                },
                {
                  type: "menuItem", title: "کالاها", subItems: [
                    { type: "link", to: "", onClick: showModalGHolders, text: "مدیریت برندها", code: 64, icon: <List style={{ color: 'blue' }} size={15} onClick={menuIconClick} /> },
                    { type: "link", to: "/BaseInfo/AddEditProductGroup", onClick: closeMenu, text: "گروهبندی کالاها", code: 128, icon: <BoxArrowDown style={{ marginTop: "2px", color: '#892e02' }} size={15} /> },
                    { type: "link", to: "/BaseInfo/SearchProduct", onClick: closeMenu, text: "جستجوی کالاها", code: 256, icon: <Search style={{ marginTop: "2px", color: 'green' }} size={15} onClick={menuIconClick} /> },
                    { type: "link", to: "/BaseInfo/AddEditProduct/0", onClick: closeMenu, text: "کالای جدید", code: 512, icon: <BoxSeam style={{ marginTop: "2px", color: 'blue' }} size={15} onClick={menuIconClick} /> },
                    { type: "link", to: "", onClick: () => showModalImportExl("product"), text: "دریافت از اکسل", code: 1024, icon: <FileEarmarkExcelFill style={{ marginTop: "2px", color: '#00804e' }} size={15} onClick={menuIconClick} /> },
                    { type: "link", to: "", onClick: showModalProductType, text: "مدیریت نوع کالا", code: 2048, icon: <BoxSeam style={{ marginTop: "2px", color: 'blue' }} size={15} onClick={menuIconClick} /> },
                    { type: "link", to: "", onClick: showModalBarcodePrint, text: "چاپ بارکد کالا", code: 4096, icon: <Upc style={{ marginTop: "2px", color: 'red' }} size={15} onClick={menuIconClick} /> },
                    { type: "link", to: "", onClick: showModalUpdateProductPrice, text: "بروزرسانی قیمت کالاها", code: 131072, icon: <Clipboard2CheckFill style={{ marginTop: "2px", color: 'gray' }} size={15} onClick={menuIconClick} /> }
                  ]
                },
                {
                  type: "menuItem", title: "پرسنل", subItems: [
                    { type: "link", to: "/BaseInfo/AddEditPersonnel/0", onClick: closeMenu, text: "پرسنل جدید", code: 8192, icon: <PersonSquare style={{ marginTop: "2px", color: '#0b8e95' }} size={15} onClick={menuIconClick} /> },
                    { type: "link", to: "/BaseInfo/SearchPersonnel", onClick: closeMenu, text: "جستجوی پرسنل", code: 16384, icon: <Search style={{ marginTop: "2px", color: 'violate' }} size={15} onClick={menuIconClick} /> }
                  ]
                },
                { type: "link", to: "/BaseInfo/UserManagement", onClick: closeMenu, text: "مدیریت کاربران", code: 32768, style: { marginRight: "8px" }, icon: <Person style={{ marginTop: "2px", color: "#b2271d" }} size={18} onClick={menuIconClick} /> },
                { type: "link", to: "", text: "مدیریت انبارها", code: 65536, onClick: showModalStgManagement, style: { marginRight: "8px" }, icon: <HouseDoorFill style={{ marginTop: "2px", color: '#7723ad' }} size={15} onClick={menuIconClick} /> }
              ]} />
            }
            {(menuName === "Main" || menuName === "Office") && checkModule(appModules, systemModules.Office) &&
              <MenuItem title="اتوماسیون اداری" className={menuName === "Office" ? "openedMenu" : ""} subsysCode={4} items={[
                {
                  type: "menuItem", title: "اطلاعیه ها", subItems: [
                    { type: "link", to: "", text: "اطلاعیه جدید", code: 2, icon: <CardText />, onClick: showModalNotice },
                    { type: "link", to: "/Office/NoticeBoard", code: 4, text: "اطلاعیه های صادر شده", icon: <CardText onClick={menuIconClick} />, onClick: closeMenu }
                  ]
                },
                {
                  type: "menuItem", title: "نامه های اداری", subItems: [
                    { type: "link", to: "/Office/AddEditInterOfficeMessage/In/0", text: "ثبت نامه وارده", code: 8, icon: <EnvelopePaper size={15} color="#00805d" />, onClick: closeMenu },
                    { type: "link", to: "/Office/AddEditInterOfficeMessage/Out/0", text: "ثبت نامه صادره", code: 16, icon: <EnvelopeCheck size={15} color="#ff3600" />, onClick: closeMenu },
                    { type: "link", to: "/Office/SearchInterOfficeMessages", text: "جستجوی نامه", code: 32, icon: <Search size={15} color="purple" />, onClick: closeMenu }
                  ]
                },
                {
                  type: "menuItem", title: "جریان کاری", code: 64, showCondition: () => checkModule(appModules, systemModules.WorkFlow), subItems: [
                    { type: "link", to: "/Office/ModalFlowStages", code: 128, onClick: closeMenu, text: "مراحل کاری", icon: <MenuButton style={{ marginTop: "2px", color: '#7723ad' }} size={15} onClick={menuIconClick} /> },
                    { type: "link", to: "/Office/UserDashboardReport", code: 128, onClick: closeMenu, text: "گردش کارهای کارتابل", icon: <MenuButtonWide style={{ marginTop: "2px", color: 'green' }} size={15} onClick={menuIconClick} /> },
                    { type: "link", to: "", onClick: showModalUserRelations, code: 256, text: "مدیریت ارتباط کاربران", icon: <PersonGear style={{ marginTop: "2px", color: '#7723ad' }} size={15} onClick={menuIconClick} /> }
                  ]
                }
              ]} />
            }
            {(menuName === "Main" || menuName === "Accounting") && checkModule(appModules, systemModules.Finances) &&
              <MenuItem title="امور مالی" className={menuName === "Accounting" ? "openedMenu" : ""} subsysCode={8} items={[
                {
                  type: "menuItem", title: "مدیریت حساب ها ", subItems: [
                    {
                      type: "link", to: "/Accounting/AccountsChart", onClick: closeMenu, text: "کدینگ حساب ها", code: 2,
                      icon: <GearWideConnected style={{ marginTop: "2px", color: '#4e1886' }} size={15} onClick={menuIconClick} />
                    },
                    {
                      type: "link", to: "/Accounting/AutoDocumentMapping", onClick: closeMenu, text: "کدینگ حساب سندهای خودکار", code: 4,
                      icon: <GearWideConnected style={{ marginTop: "2px", color: '#4e1886' }} size={15} onClick={menuIconClick} />
                    },
                    {
                      type: "link", to: "/Accounting/ManageCostCenters", onClick: closeMenu, text: "مدیریت مراکز هزینه", code: 8,
                      icon: <Coin style={{ marginTop: "2px", color: '#4e1886' }} size={15} onClick={menuIconClick} />
                    },
                    {
                      type: "link", to: "", onClick: showModalPos, text: "تعریف کارتخوان", code: 16,
                      icon: <CreditCard style={{ marginTop: "2px", color: 'green' }} size={15} onClick={menuIconClick} />
                    },
                    {
                      type: "link", to: "", onClick: showModalBankAcc, text: "حساب های بانکی", code: 32,
                      icon: <Bank style={{ marginTop: "2px", color: 'red' }} size={15} onClick={menuIconClick} />
                    }
                  ]
                },
                {
                  type: "menuItem", title: "سندهای حسابداری", subItems: [
                    {
                      type: "link", to: "/Accounting/AddEditDocument/0", onClick: closeMenu, text: "صدور سند جدید", code: 64,
                      icon: <FileEarmarkPost style={{ marginTop: "2px", color: '#4e1886' }} size={15} onClick={menuIconClick} />
                    },
                    {
                      type: "link", to: "/Accounting/SearchDocuments", onClick: closeMenu, text: "جستجوی سند حسابداری", code: 128,
                      icon: <Search style={{ marginTop: "2px", color: 'rgb(167 37 33)' }} size={15} onClick={menuIconClick} />
                    },
                    {
                      type: "link", to: "", onClick: (e) => showModalSpecialDocuments(e, "AccountDeposit"), text: "واریز به حساب", code: 256,
                      icon: <Bank2 style={{ marginTop: "2px", color: 'green' }} size={15} onClick={menuIconClick} />
                    },
                    {
                      type: "link", to: "", onClick: (e) => showModalSpecialDocuments(e, "AccountWithdrawal"), text: "برداشت از حساب", code: 512,
                      icon: <Bank2 style={{ marginTop: "2px", color: 'red' }} size={15} onClick={menuIconClick} />
                    },
                    {
                      type: "link", to: "", onClick: (e) => showModalSpecialDocuments(e, "CashReceive"), text: "دریافت نقد", code: 1024,
                      icon: <CashCoin style={{ marginTop: "2px", color: '#0089ff' }} size={15} onClick={menuIconClick} />
                    },
                    {
                      type: "link", to: "", onClick: (e) => showModalSpecialDocuments(e, "CashPay"), text: "پرداخت نقد", code: 2048,
                      icon: <CashCoin style={{ marginTop: "2px", color: 'purple' }} size={15} onClick={menuIconClick} />
                    },
                    {
                      type: "link", to: "", onClick: (e) => showModalSpecialDocuments(e, "DurationalSettlement"), text: "تسویه حساب دوره ای", code: 4096,
                      icon: <CashCoin style={{ marginTop: "2px", color: 'green' }} size={15} onClick={menuIconClick} />
                    },
                    {
                      type: "link", to: "", onClick: (e) => showModalSpecialDocuments(e, "PosDeposit"), text: "حساب کارتخوان", code: 8192,
                      icon: <CreditCard style={{ marginTop: "2px", color: '#615f5f' }} size={15} onClick={menuIconClick} />
                    },
                    {
                      type: "link", to: "", onClick: (e) => showModalSpecialDocuments(e, "TransferAccount"), text: "انتقال بین حساب ها", code: 16384,
                      icon: <Bank style={{ marginTop: "2px", color: '#7500ff' }} size={15} onClick={menuIconClick} />
                    },
                    { type: "link", to: "", onClick: showModalPermanetDocs, text: "دائمی کردن سندها", code: 32768, icon: <Toggle2On style={{ marginTop: "2px", color: '#4e1886' }} size={15} onClick={menuIconClick} /> },
                    { type: "link", to: "", onClick: showModalMergeDocs, text: "ادغام سندها", code: 65536, icon: <Columns style={{ marginTop: "2px", color: 'green' }} size={15} onClick={menuIconClick} /> },
                    { type: "link", to: "", onClick: showModalSortDocs, text: "مرتب سازی سندها", code: 131072, icon: <SortNumericDown style={{ marginTop: "2px", color: 'blue' }} size={15} onClick={menuIconClick} /> }
                  ]
                },
                {
                  type: "menuItem", title: "چک ها", subItems: [
                    { type: "link", to: "", onClick: (e) => showModalChequeFunction(e, chequeStatuses.in_1_RecieveCheque, false), text: "دریافت چک", code: 8589934592, icon: <CreditCard2FrontFill color="#0088ff" size={15} onClick={menuIconClick} /> },
                    { type: "link", to: "", onClick: (e) => showModalChequeFunction(e, chequeStatuses.in_1_RecieveCheque, true), text: "دریافت مرکب", code: 17179869184, icon: <CreditCard2Front color="seagreen" size={15} onClick={menuIconClick} /> },
                    { type: "link", to: "", onClick: (e) => showModalChequeFunction(e, chequeStatuses.in_2_PutInAccount, false), text: "به حساب گذاشتن چک", code: 34359738368, icon: <CreditCard2FrontFill color="green" size={15} onClick={menuIconClick} /> },
                    { type: "link", to: "", onClick: (e) => showModalChequeFunction(e, chequeStatuses.in_3_GiveToCustomer, false), text: "خرج کردن/نقد فوری", code: 68719476736, icon: <CreditCard2Front color="red" size={15} onClick={menuIconClick} /> },
                    { type: "link", to: "", onClick: (e) => showModalChequeFunction(e, chequeStatuses.in_4_Cash, false), text: "وصول چک", code: 137438953472, icon: <CreditCard2FrontFill color="#333387" size={15} onClick={menuIconClick} /> },
                    { type: "link", to: "", onClick: (e) => showModalChequeFunction(e, chequeStatuses.in_5_NotCash, false), text: "عدم وصول چک", code: 274877906944, icon: <CreditCard2Front color="#333387" size={15} onClick={menuIconClick} /> },
                    { type: "link", to: "", onClick: (e) => showModalChequeFunction(e, chequeStatuses.in_6_ReturnAndCustomerPay, false), text: "عودت چک دریافتی", code: 549755813888, icon: <CreditCard2FrontFill color="red" size={15} onClick={menuIconClick} /> },
                    { type: "link", to: "", onClick: (e) => showModalChequeFunction(e, chequeStatuses.out_4_PaidChequeReversal, false), text: "عودت چک پرداختی", code: 1099511627776, icon: <CreditCard2Front color="blue" size={15} onClick={menuIconClick} /> },
                    { type: "link", to: "", onClick: (e) => showModalChequeFunction(e, chequeStatuses.out_3_CustomerReturns, false), text: "دریافت چک برگشتی", code: 2199023255552, icon: <CreditCard2FrontFill color="blue" size={15} onClick={menuIconClick} /> },
                    { type: "space" },
                    { type: "link", to: "", onClick: (e) => showModalChequeFunction(e, chequeStatuses.out_1_PayCheque, false), text: "پرداخت چک", code: 4398046511104, icon: <CreditCard2Front color="purple" size={15} onClick={menuIconClick} /> },
                    { type: "link", to: "", onClick: (e) => showModalChequeFunction(e, chequeStatuses.out_1_PayCheque, true), text: "پرداخت مرکب", code: 8796093022208, icon: <CreditCard2FrontFill color="#ae420d" size={15} onClick={menuIconClick} /> },
                    { type: "link", to: "", onClick: (e) => showModalChequeFunction(e, chequeStatuses.out_2_PassCheque, false), text: "پاس شدن چکهای پرداختی", code: 17592186044416, icon: <CreditCard2Front color="green" size={15} onClick={menuIconClick} /> },
                    { type: "link", to: "", onClick: (e) => showModalChequeFunction(e, chequeStatuses.out_3_CustomerReturns, false), text: "برگشت چکهای پرداختی", code: 35184372088832, icon: <CreditCard2FrontFill color="red" size={15} onClick={menuIconClick} /> },
                    { type: "line" },
                    { type: "link", to: "/Accounting/SearchCheques", onClick: closeMenu, text: "جستجوی چک", code: 70368744177664, icon: <Search color="#ff5200" size={15} onClick={menuIconClick} /> },
                    { type: "link", to: "", onClick: showModalChequeBook, text: "تعریف دسته چک", code: 140737488355328, icon: <CreditCard2Front color="blue" size={15} onClick={menuIconClick} /> }

                  ]
                },
                {
                  type: "menuItem", title: "ترازهای مالی", subItems: [
                    {
                      type: "link", to: "/Accounting/AccountingBalance/0/0", code: 262144, onClick: closeMenu, text: "تراز گروه",
                      icon: <Grid1x2Fill style={{ marginTop: "2px", color: '#4e1886' }} size={15} onClick={menuIconClick} />
                    },
                    {
                      type: "link", to: "/Accounting/AccountingBalance/1/0", code: 524288, onClick: closeMenu, text: "تراز کل",
                      icon: <GridFill style={{ marginTop: "2px", color: 'rgb(167 37 33)' }} size={15} onClick={menuIconClick} />
                    }
                    ,
                    {
                      type: "link", to: "/Accounting/AccountingBalance/2/0", code: 1048576, onClick: closeMenu, text: "تراز معین",
                      icon: <UiChecksGrid style={{ marginTop: "2px", color: 'blue' }} size={15} onClick={menuIconClick} />
                    }
                    ,
                    {
                      type: "link", to: "/Accounting/AccountingBalance/3/0", code: 2097152, onClick: closeMenu, text: "تراز تفصیلی",
                      icon: <Grid3x3GapFill style={{ marginTop: "2px", color: '#bb1370' }} size={15} onClick={menuIconClick} />
                    },
                    {
                      type: "link", to: "/Accounting/AccountBalanceReport", code: 4194304, onClick: closeMenu, text: "ترازنامه",
                      icon: <BookHalf style={{ marginTop: "2px", color: '#bb1370' }} size={15} onClick={menuIconClick} />
                    }]
                },
                {
                  type: "menuItem", title: "دفاتر حساب", subItems: [

                    {
                      type: "link", to: "/Accounting/AccountingBook/0/0/0", code: 8388608, onClick: closeMenu, text: "دفتر حساب گروه",
                      icon: <Book style={{ marginTop: "2px", color: '#4e1886' }} size={15} onClick={menuIconClick} />
                    },
                    {
                      type: "link", to: "/Accounting/AccountingBook/1/0/0", code: 16777216, onClick: closeMenu, text: "دفتر حساب کل",
                      icon: <Book style={{ marginTop: "2px", color: 'rgb(167 37 33)' }} size={15} onClick={menuIconClick} />
                    }
                    ,
                    {
                      type: "link", to: "/Accounting/AccountingBook/2/0/0", code: 33554432, onClick: closeMenu, text: "دفتر حساب معین",
                      icon: <BookHalf style={{ marginTop: "2px", color: 'blue' }} size={15} onClick={menuIconClick} />
                    }
                    ,
                    {
                      type: "link", to: "/Accounting/AccountingBook/3/0/0", code: 67108864, onClick: closeMenu, text: "دفتر حساب تفصیلی",
                      icon: <BookFill style={{ marginTop: "2px", color: '#bb1370' }} size={15} onClick={menuIconClick} />
                    }]
                },
                {
                  type: "menuItem", title: "گردش حساب", subItems: [
                    {
                      type: "link", to: "/Accounting/ViewAccountsReport/Banks", code: 134217728, onClick: closeMenu, text: "گردش حساب بانک ها",
                      icon: <Building style={{ marginTop: "2px", color: 'blue' }} size={15} onClick={menuIconClick} />
                    },
                    {
                      type: "link", to: "/Accounting/ViewAccountsReport/CashTarget", code: 268435456, onClick: closeMenu, text: "گردش حساب صندوق",
                      icon: <CashStack style={{ marginTop: "2px", color: 'orange' }} size={15} onClick={menuIconClick} />
                    },
                    {
                      type: "link", to: "/Accounting/ViewAccountsReport/Customers", code: 536870912, onClick: closeMenu, text: "گردش حساب اشخاص",
                      icon: <PersonLinesFill style={{ marginTop: "2px", color: '#0f6d6f' }} size={17} onClick={menuIconClick} />
                    }]
                },
                {
                  type: "menuItem", title: "گزارش ها", subItems: [
                    {
                      type: "link", to: "/Accounting/CreditorDebtorList", code: 1073741824, onClick: closeMenu, text: "لیست بدهکاران/بستانکاران",
                      icon: <JournalText style={{ marginTop: "2px", color: '#0f6d6f' }} size={15} onClick={menuIconClick} />
                    },
                    {
                      type: "link", to: "", onClick: showModalDocumentCover, text: "روکش سند حسابداری", code: 2147483648,
                      icon: <JournalAlbum style={{ marginTop: "2px", color: '#100f6f' }} size={15} onClick={menuIconClick} />
                    },
                    {
                      type: "link", to: "", onClick: showModalElectronicAccBook, text: "گزارش دفاتر الکترونیک ", code: 281474976710656,
                      icon: <JournalAlbum style={{ marginTop: "2px", color: '#100f6f' }} size={15} onClick={menuIconClick} />
                    },
                    {
                      type: "link", to: "/Accounting/BenefitItems", onClick: closeMenu, text: "صورتحساب سود و زیان", code: 4294967296,
                      icon: <JournalAlbum style={{ marginTop: "2px", color: '#100f6f' }} size={15} onClick={menuIconClick} />
                    }

                  ]
                }
              ]}
              />
            }
            {(menuName === "Main" || menuName === "Sale") &&
              <MenuItem title="فروش و انبار" className={menuName === "Sale" ? "openedMenu" : ""} subsysCode={16} items={[
                {
                  type: "menuItem", title: "فاکتورهای انبار", showCondition: () => checkModule(appModules, systemModules.StorageInvoice), subItems: [
                    {
                      type: "link", to: `/Sale/Invoice/${invoiceTypes.PreSale}/0/false`, onClick: closeMenu, text: "پیش فاکتور فروش", code: 2,
                      icon: <FileEarmarkRuled style={{ marginTop: "2px", color: '#4e1886' }} size={15} onClick={menuIconClick} />
                    },
                    {
                      type: "link", to: `/Sale/Invoice/${invoiceTypes.Sale}/0/false`, onClick: closeMenu, text: "فاکتور فروش", code: 4,
                      icon: <FileEarmarkRuledFill style={{ marginTop: "2px", color: '#4e1886' }} size={15} onClick={menuIconClick} />
                    },
                    {
                      type: "link", to: `/Sale/Invoice/${invoiceTypes.ReturnFromSale}/0/false`, onClick: closeMenu, text: "برگشت از  فروش", code: 8,
                      icon: <FileEarmarkRuledFill style={{ marginTop: "2px", color: 'red' }} size={15} onClick={menuIconClick} />
                    },
                    {
                      type: "link", to: `/Sale/Invoice/${invoiceTypes.PrePurchase}/0/false`, onClick: closeMenu, text: "پیش فاکتور خرید", code: 16,
                      icon: <FileEarmarkText style={{ marginTop: "2px" }} size={15} onClick={menuIconClick} />
                    },
                    {
                      type: "link", to: `/Sale/Invoice/${invoiceTypes.Purchase}/0/false`, onClick: closeMenu, text: "فاکتور خرید", code: 32,
                      icon: <FileEarmarkTextFill style={{ marginTop: "2px" }} size={15} onClick={menuIconClick} />
                    },
                    {
                      type: "link", to: `/Sale/Invoice/${invoiceTypes.ReturnFromPurchase}/0/false`, onClick: closeMenu, text: "برگشت از خرید", code: 64,
                      icon: <FileEarmarkTextFill style={{ marginTop: "2px" }} color="red" size={15} onClick={menuIconClick} />
                    },
                    {
                      type: "link", to: `/Sale/Invoice/${invoiceTypes.Resid}/0/false`, onClick: closeMenu, text: "رسید انبار", code: 128,
                      icon: <FileEarmarkPost style={{ marginTop: "2px", color: 'rgb(55 124 142)' }} size={15} onClick={menuIconClick} />
                    },
                    {
                      type: "link", to: `/Sale/Invoice/${invoiceTypes.Havaleh}/0/false`, onClick: closeMenu, text: "حواله انبار", code: 256,
                      icon: <FileEarmarkPostFill style={{ marginTop: "2px", color: '#374c8e' }} size={15} onClick={menuIconClick} />
                    },
                    {
                      type: "link", to: `/Sale/Invoice/${invoiceTypes.Transfer}/0/false`, onClick: closeMenu, text: "انتقال بین انبارها", code: 512,
                      icon: <FileEarmarkText style={{ marginTop: "2px" }} size={15} onClick={menuIconClick} />
                    },
                    {
                      type: "link", to: `/Sale/Invoice/${invoiceTypes.Borrow}/0/false`, onClick: closeMenu, text: "حواله به نماینده/تکنسین", code: 1024,
                      icon: <FileEarmarkRuled style={{ marginTop: "2px", color: 'green' }} size={15} onClick={menuIconClick} />
                    },
                    {
                      type: "link", to: `/Sale/Invoice/${invoiceTypes.ReturnFromBorrow}/0/false`, onClick: closeMenu, text: "برگشت حواله به نماینده/تکنسین", code: 2048,
                      icon: <FileEarmarkRuledFill style={{ marginTop: "2px", color: '#aa1550' }} size={15} onClick={menuIconClick} />
                    },
                    {
                      type: "link", to: `/Sale/Invoice/${invoiceTypes.OldParts}/0/false`, onClick: closeMenu, text: "در قبال داغی", code: 4096,
                      icon: <FileEarmarkPost style={{ marginTop: "2px", color: '#ff8100' }} size={15} onClick={menuIconClick} />
                    },
                    {
                      type: "link", to: "/Sale/SearchInvoice", onClick: closeMenu, text: "جستجوی فاکتور", code: 8192,
                      icon: <div style={{ position: "relative", display: "inline-block" }}>
                        <Search size={13} color="#0f0389" fontWeight="bold" style={{ position: "absolute", marginTop: "8px", scale: "1.1", left: "10px" }} />
                        <FileEarmarkRuled style={{ marginTop: "2px", color: 'rgb(167 37 33)' }} size={15} onClick={menuIconClick} />
                      </div>
                    },
                    {
                      type: "link", to: "#", onClick: rewriteInvoice, text: "بازنویسی فاکتورها", code: 16384,
                      icon: <div style={{ position: "relative", display: "inline-block" }}>
                        {rewritePending ?
                          <Loader type="BallTriangle" width={18} height={18} color="#bb1370" style={{ padding: 0, margin: 0 }} /> :
                          <PencilSquare size={15} color="#0f0389" fontWeight="bold" style={{ marginTop: "2px", color: '#aa1550' }} onClick={menuIconClick} />}
                      </div>
                    },
                  ]
                },
                {
                  type: "menuItem", title: "خرید و فروش", showCondition: () => checkModule(appModules, systemModules.Sale), subItems: [
                    {
                      type: "link", to: `/Sale/Invoice/${invoiceTypes.PreSale}/0/true`, onClick: closeMenu, text: "پیش فاکتور فروش رسمی", code: 32768,
                      icon: <FilePostFill style={{ marginTop: "2px", color: '#d509e3' }} size={15} onClick={menuIconClick} />
                    },
                    {
                      type: "link", to: `/Sale/Invoice/${invoiceTypes.Sale}/0/true`, onClick: closeMenu, text: "فاکتور فروش رسمی", code: 65536,
                      icon: <FilePost style={{ marginTop: "2px", color: 'green' }} size={15} onClick={menuIconClick} />
                    },
                    {
                      type: "link", to: `/Sale/Invoice/${invoiceTypes.ReturnFromSale}/0/true`, onClick: closeMenu, text: "برگشت از  فروش رسمی", code: 131072,
                      icon: <FilePost style={{ marginTop: "2px", color: 'red' }} size={15} onClick={menuIconClick} />
                    },
                    {
                      type: "link", to: `/Sale/Invoice/${invoiceTypes.PrePurchase}/0/true`, onClick: closeMenu, text: "پیش فاکتور خرید رسمی", code: 262144,
                      icon: <FileSpreadsheet style={{ marginTop: "2px", color: "#080f81" }} size={15} onClick={menuIconClick} />
                    },
                    {
                      type: "link", to: `/Sale/Invoice/${invoiceTypes.Purchase}/0/true`, onClick: closeMenu, text: "فاکتور خرید رسمی", code: 524288,
                      icon: <FileSpreadsheetFill style={{ marginTop: "2px", color: "#087681" }} size={15} onClick={menuIconClick} />
                    },
                    {
                      type: "link", to: `/Sale/Invoice/${invoiceTypes.ReturnFromPurchase}/0/true`, onClick: closeMenu, text: "برگشت از خرید رسمی", code: 1048576,
                      icon: <FileSpreadsheetFill style={{ marginTop: "2px", color: "red" }} size={15} onClick={menuIconClick} />
                    },
                    {
                      type: "link", to: `/Sale/Invoice/${invoiceTypes.ServiceInvoice}/0/true`, onClick: closeMenu, text: "فروش کالا و خدمات", code: 2097152,
                      icon: <FileEarmarkPost style={{ marginTop: "2px", color: '#ff8100' }} size={15} onClick={menuIconClick} />
                    },
                    {
                      type: "link", to: `/Sale/TaxPayerInvoices`, onClick: closeMenu, text: "ارسال فاکتورها به دارایی", code: 4194304,
                      icon: <FileEarmarkTextFill style={{ marginTop: "2px" }} size={15} onClick={menuIconClick} />
                    },
                    {
                      type: "link", to: "/Sale/SearchFormalInvoice", onClick: closeMenu, text: "جستجوی فاکتور", code: 8388608,
                      icon: <div style={{ position: "relative", display: "inline-block" }}>
                        <Search size={13} color="#0f0389" fontWeight="bold" style={{ position: "absolute", marginTop: "8px", scale: "1.1", left: "10px" }} />
                        <FileEarmarkRuled style={{ marginTop: "2px", color: 'rgb(167 37 33)' }} size={15} onClick={menuIconClick} />
                      </div>
                    },
                  ]
                },
                {
                  type: "menuItem", title: "گزارش ها", showCondition: () => checkModule(appModules, systemModules.Sale), subItems: [
                    {
                      type: "link", to: "/Sale/StorageValueReport", onClick: closeMenu, text: "گزارش ارزش انبار", code: 16777216,
                      icon: <ClipboardData style={{ marginTop: "2px", color: "purple" }} size={15} onClick={menuIconClick} />
                    },
                    {
                      type: "link", to: "/Sale/StorageStatusReport", onClick: closeMenu, text: "گزارش وضعیت انبار", code: 33554432,
                      icon: <List style={{ marginTop: "2px", color: "red" }} size={15} onClick={menuIconClick} />
                    },
                    {
                      type: "link", to: "/Sale/InventoryTurnoverReport", onClick: closeMenu, text: "گزارش کاردکس کالا", code: 67108864,
                      icon: <BoxSeam style={{ marginTop: "2px", color: "green" }} size={15} onClick={menuIconClick} />
                    },
                    {
                      type: "link", to: "/Sale/InventoryTurnoverForAllProducts", onClick: closeMenu, text: "گزارش جامع موجودی", code: 134217728,
                      icon: <Box2 style={{ marginTop: "2px", color: "orange" }} size={15} onClick={menuIconClick} />
                    },
                    {
                      type: "link", to: "/Sale/InvoiceDetailsReport", onClick: closeMenu, text: "گزارش ریز فاکتورها", code: 268435456,
                      icon: <FileEarmarkText style={{ marginTop: "2px", color: "blue" }} size={15} onClick={menuIconClick} />
                    },
                    {
                      type: "link", to: "/Sale/ProductSerialTurnoverInStorage", onClick: closeMenu, text: "گردش سریال کالاهای انبار", code: 536870912,
                      icon: <FileEarmarkText style={{ marginTop: "2px", color: "blue" }} size={15} onClick={menuIconClick} />
                    }

                  ]
                }
              ]}
              />
            }
            {(menuName === "Main" || menuName === "Production") &&
              <MenuItem title="تولید" className={menuName === "Production" ? "openedMenu" : ""} subsysCode={32} items={[
                {
                  type: "menuItem", title: "دمونتاژ", showCondition: () => checkModule(appModules, systemModules.Sale), subItems: [
                    { type: "link", text: "فرم دمونتاژ", code: 2, to: "/Production/Disassembly/0", onClick: closeMenu, icon: <ColumnsGap style={{ marginTop: "2px", color: "red" }} size={15} onClick={menuIconClick} /> },
                    { type: "link", text: "جستجوی فرم", code: 4, to: "/Production/SearchDisassembly", onClick: closeMenu, icon: <Search style={{ marginTop: "2px", color: "blue" }} size={15} onClick={menuIconClick} /> }
                  ]
                },
                {
                  type: "menuItem", title: "تولید و مونتاژ", showCondition: () => checkModule(appModules, systemModules.Sale), subItems: [
                    { type: "link", text: "فرمول ساخت", code: 8, to: `/Production/BoM/0/${bomTypes.BoM}/0`, onClick: closeMenu, icon: <FileEarmarkRuled style={{ color: "blue" }} size={15} onClick={menuIconClick} /> },
                    { type: "link", text: "برآورد تولید", code: 16, to: `/Production/BoM/0/${bomTypes.ProductionEstimate}/0`, onClick: closeMenu, icon: <FileEarmarkDiff style={{ color: "red" }} size={15} onClick={menuIconClick} /> },
                    { type: "link", text: "مونتاژ", code: 32, to: `/Production/BoM/0/${bomTypes.ProductionInvoice}/1`, onClick: closeMenu, icon: <FileEarmarkPost style={{ color: "#389f7e" }} size={15} onClick={menuIconClick} /> },
                    { type: "link", text: "تولید", code: 64, to: `/Production/BoM/0/${bomTypes.ProductionInvoice}/0`, onClick: closeMenu, icon: <FileEarmarkSpreadsheet style={{ color: "black" }} size={15} onClick={menuIconClick} /> },
                    { type: "link", text: "جستجوی فرم", code: 128, to: "/Production/SearchBoM", onClick: closeMenu, icon: <Search style={{ marginTop: "2px", color: "blue" }} size={15} onClick={menuIconClick} /> }
                  ]
                },
                { type: "link", text: "مدیریت وضعیت ها", code: 256, to: "#", onClick: showModalBoMStaus, icon: <ColumnsGap size={15} onClick={menuIconClick} /> }
              ]} />
            }
            {(menuName === "Main" || menuName === "Services") &&
              <MenuItem title="خدمات پس از فروش" className={menuName === "Services" ? "openedMenu" : ""} subsysCode={64} items={[
                {
                  type: "menuItem", title: "مدیریت پذیرش", showCondition: () => checkModule(appModules, systemModules.Services), subItems: [
                    { type: "link", to: "/Services/Service/0/0", onClick: closeMenu, text: "ثبت پذیرش", code: 2, icon: <Tools style={{ marginTop: "2px", color: '#9f247e' }} size={15} onClick={menuIconClick} /> },
                    { type: "link", to: "", onClick: showModalSaveSerive, text: "ثبت دسته ای پذیرش", code: 2199023255552, icon: <Tools style={{ marginTop: "2px", color: '#28109fff' }} size={15} onClick={menuIconClick} /> },
                    { type: "link", to: "/Services/tasks", onClick: closeMenu, text: "کارهای من", code: 4, icon: <UiChecksGrid style={{ marginTop: "2px", color: 'red' }} size={15} onClick={menuIconClick} /> },
                    { type: "link", to: "/Services/myTasks", onClick: closeMenu, text: "جستجوی کارها", code: 8, icon: <Stickies style={{ color: '#0f75b1' }} size={15} onClick={menuIconClick} /> },
                    { type: "link", to: "/Services/CustomerRequestWithoutLoginList", onClick: closeMenu, text: "جستجوی درخواستهای سریع", code: 16, icon: <Files style={{ color: 'blue' }} onClick={menuIconClick} /> },
                    { type: "link", to: "", onClick: showModalDefined, text: "مدیریت خدمات و تعرفه ها", code: 32, icon: <CardList style={{ color: 'green' }} onClick={menuIconClick} /> },
                    { type: "link", to: "", onClick: showModalProductBugs, text: "مدیریت ایرادات فنی", code: 64, icon: <Bug style={{ color: '#800000' }} onClick={menuIconClick} /> },
                    { type: "link", to: "", onClick: showModalPA, text: "مدیریت لوازم همراه", code: 128, icon: <Basket2 style={{ color: '#006180' }} onClick={menuIconClick} /> },
                    { type: "link", to: "", onClick: showModalSSM, text: "مدیریت وضعیت سرویس", code: 256, icon: <Toggle2On style={{ color: 'gray' }} onClick={menuIconClick} /> },
                    { type: "link", to: "/Services/ServiceRejectHistory", onClick: closeMenu, text: "تاریخچه انصراف تکنسین ها", code: 512, icon: <UiChecksGrid style={{ marginTop: "2px", color: 'red' }} size={15} onClick={menuIconClick} /> },
                    { type: "link", to: "/Services/ManageTransportationChart", onClick: closeMenu, text: "مدیریت ایاب و ذهاب", code: 1024, icon: <Truck style={{ marginTop: "2px", color: 'purple' }} size={15} onClick={menuIconClick} /> },
                    { type: "link", to: "/Services/ManageSendingStaffList", onClick: closeMenu, text: "مدیریت اعزام تکنسین", code: 2048, icon: <CardList style={{ marginTop: "2px", color: 'blue' }} size={15} onClick={menuIconClick} /> },
                    { type: "link", to: "/Services/FixableSerialsReport", onClick: closeMenu, text: "دستگاههای در دست تعمیر", code: 4096, icon: <Toggles2 color="purple" style={{ marginTop: "2px" }} size={16} onClick={menuIconClick} /> },
                    { type: "link", to: "/Services/VIPServices", onClick: closeMenu, text: "سرویس های ویژه", code: 8192, icon: <ClockHistory color="gray" style={{ marginTop: "2px" }} size={16} onClick={menuIconClick} /> },
                    { type: "link", to: "/Services/CyclicServices", onClick: closeMenu, text: "سرویس های دوره ای", code: 549755813888, icon: <ClockHistory color="blue" style={{ marginTop: "2px" }} size={16} onClick={menuIconClick} /> }
                  ]
                },
                {
                  type: "menuItem", title: "مدیریت نمایندگان/تکنسین ها", showCondition: () => checkModule(appModules, systemModules.Agents), subItems: [
                    { type: "link", to: "/Services/AddEditStaff/true/0", onClick: closeMenu, text: "نماینده جدید", code: 16384, icon: <PersonPlusFill color="#ff4000" style={{ marginTop: "2px" }} size={17} onClick={menuIconClick} /> },
                    { type: "link", to: "/Services/AddEditStaff/false/0", onClick: closeMenu, text: "تکنسین جدید", code: 32768, icon: <PersonPlus color="green" style={{ marginTop: "2px" }} size={17} onClick={menuIconClick} /> },
                    { type: "link", to: "/Services/SearchStaff", onClick: closeMenu, text: "جستجوی نماینده/تکنسین", code: 65536, icon: <Search color="blue" style={{ marginTop: "2px" }} size={15} onClick={menuIconClick} /> },

                  ]
                },
                {
                  type: "menuItem", title: "مدیریت درخواستها", showCondition: () => checkModule(appModules, systemModules.Services), subItems: [
                    { type: "link", to: "/Services/PartRequest/0", onClick: closeMenu, text: "ثبت درخواست", code: 131072, icon: <LayoutTextWindow style={{ color: "blue" }} onClick={menuIconClick} /> },
                    { type: "link", to: "/Services/SearchProductRequest", onClick: closeMenu, text: "جستجوی درخواست", code: 262144, icon: <Files style={{ color: 'red' }} onClick={menuIconClick} /> }
                  ]
                },
                {
                  type: "menuItem", showCondition: () => checkModule(appModules, systemModules.GuaranteeCheck), title: "گارانتی", subItems: [
                    { type: "link", to: "", onClick: showModalActiveCard, text: "فعال سازی گارانتی", code: 524288, icon: <Check2Square style={{ color: 'green' }} size={15} onClick={menuIconClick} /> },
                    { type: "link", to: "/Services/GuaranteeCardsManagement", onClick: closeMenu, text: "مدیریت کارت های گارانتی", code: 1048576, icon: <Files style={{ color: 'red' }} onClick={menuIconClick} /> },
                    { type: "link", to: "", onClick: showModalAssignP2GC, text: "تخصیص کالا به کارت گارانتی", code: 4398046511104, icon: <Check2Square style={{ color: 'orange' }} size={15} onClick={menuIconClick} /> },
                    { type: "link", to: "/Services/GuaranteeCardsAssignedToAgencies", onClick: closeMenu, text: "کارتهای تخصیصی به نماینده", code: 2097152, icon: <Files style={{ color: 'blue' }} onClick={menuIconClick} /> }

                  ]
                }
                ,
                {
                  type: "menuItem", title: "گزارش ها", showCondition: () => checkModule(appModules, systemModules.Services), subItems: [
                    { type: "link", to: "/Services/ProductBugReport", onClick: closeMenu, text: "گزارش ایرادات برحسب نوع", code: 4194304, icon: <Bug color="#ff4000" style={{ marginTop: "2px" }} size={16} onClick={menuIconClick} /> },
                    { type: "link", to: "/Services/ProductBugDetailedReport", onClick: closeMenu, text: "گزارش ایرادات", code: 8388608, icon: <Bug color="#ff4000" style={{ marginTop: "2px" }} size={16} onClick={menuIconClick} /> },
                    { type: "link", to: "/Services/ServiceAccountingReportByProductType", onClick: closeMenu, text: "ارزش خدمات بر حسب نوع محصول", code: 16777216, icon: <Calculator color="blue" style={{ marginTop: "2px" }} size={16} onClick={menuIconClick} /> },
                    { type: "link", to: "/Services/ServiceAccountingReport", onClick: closeMenu, text: "گزارش ریالی سرویس ها", code: 33554432, icon: <Calculator color="black" style={{ marginTop: "2px" }} size={16} onClick={menuIconClick} /> },
                    { type: "link", to: "/Services/ServiceCostAndIncome", onClick: closeMenu, text: "گزارش سود/زیان خدمات", code: 67108864, icon: <Calculator color="black" style={{ marginTop: "2px" }} size={16} onClick={menuIconClick} /> },
                    { type: "link", to: "/Services/ServiceCostAndIncomeByProductType", onClick: closeMenu, text: "سود/زیان خدمات به تفکیک نوع", code: 134217728, icon: <Calculator color="black" style={{ marginTop: "2px" }} size={16} onClick={menuIconClick} /> },
                    { type: "link", to: "/Services/ServiceCostAndIncomeByProduct", onClick: closeMenu, text: "سود/زیان خدمات به تفکیک محصول", code: 268435456, icon: <Calculator color="black" style={{ marginTop: "2px" }} size={16} onClick={menuIconClick} /> },
                    { type: "link", to: "/Services/DefinedServiceCostAggregate", onClick: closeMenu, text: "گزارش تجمیعی خدمات و تعرفه ها", code: 536870912, icon: <FileEarmarkBarGraph color="blue" style={{ marginTop: "2px" }} size={16} onClick={menuIconClick} /> },
                    { type: "link", to: "/Services/StaffPerformanceTotalCost", onClick: closeMenu, text: "عملکرد تکنسین(مجموع ریالی)", code: 1073741824, icon: <FileEarmarkBarGraphFill color="red" style={{ marginTop: "2px" }} size={16} onClick={menuIconClick} /> },
                    { type: "link", to: "/Services/StaffPerformanceTotalCostReportMonthly", onClick: closeMenu, text: "عملکرد تکنسین(ماهانه)", code: 2147483648, icon: <FileEarmarkBarGraphFill color="red" style={{ marginTop: "2px" }} size={16} onClick={menuIconClick} /> },
                    { type: "link", to: "/Services/StaffPerformanceServiceCostList/0", onClick: closeMenu, text: "عملکرد تکنسین(لیستی)", code: 1099511627776, icon: <FileEarmarkBarGraph color="red" style={{ marginTop: "2px" }} size={16} onClick={menuIconClick} /> },
                    { type: "link", to: "/Services/ServiceCountByStatusReport", onClick: closeMenu, text: "گزارش تعدادی وضعیت سرویس ها", code: 4294967296, icon: <FileEarmarkBarGraphFill color="orange" style={{ marginTop: "2px" }} size={16} onClick={menuIconClick} /> },
                    { type: "link", to: "/Services/ServiceStageAndStatus", onClick: closeMenu, text: "گزارش گردش سرویس", code: 8589934592, icon: <FileEarmarkBarGraph color="green" style={{ marginTop: "2px" }} size={16} onClick={menuIconClick} /> },
                    { type: "link", to: "/Services/ServiceTurnaroundTimeReport", onClick: closeMenu, text: "زمان گردش کار خدمات", code: 17179869184, icon: <ClockHistory color="purple" style={{ marginTop: "2px" }} size={16} onClick={menuIconClick} /> },
                    { type: "link", to: "/Services/ReportGenerator", onClick: closeMenu, text: "گزارش ساز سرویس ها", code: 34359738368, icon: <FileEarmarkBarGraphFill color="orange" style={{ marginTop: "2px" }} size={16} onClick={menuIconClick} /> },
                    { type: "link", to: "/Services/ServiceCountByStageReport", onClick: closeMenu, text: "ورود و خروج سیستم خدمات", code: 68719476736, icon: <FileEarmarkBarGraph color="green" style={{ marginTop: "2px" }} size={16} onClick={menuIconClick} /> },
                    { type: "link", to: "/Services/SwappedSerialsReport", onClick: closeMenu, text: "گزارش دستگاههای تعویضی", code: 137438953472, icon: <Toggles2 color="purple" style={{ marginTop: "2px" }} size={16} onClick={menuIconClick} /> },
                    { type: "link", to: "/Services/SerialHistoryReport", onClick: closeMenu, text: "گزارش تاریخچه سریال ها", code: 274877906944, icon: <ClockHistory color="blue" style={{ marginTop: "2px" }} size={16} onClick={menuIconClick} /> },
                  ]
                }]}
              />
            }
            {(menuName === "Main" || menuName === "CRM") && checkModule(appModules, systemModules.CRM) &&
              <MenuItem title="مشتریان" className={menuName === "CRM" ? "openedMenu" : ""} subsysCode={128}
                items={[
                  {
                    type: "menuItem", title: "مشتریان", subItems: [
                      { type: "link", to: "", onClick: showModalPreCustJob, text: "رسته شغلی", code: 2, icon: <CardText style={{ marginTop: "2px", color: '#d83904' }} size={15} onClick={menuIconClick} /> },
                      { type: "link", to: "/CRM/ModalCustomerStatus", onClick: closeMenu, text: "وضعیت مشتری", code: 4, icon: <PersonBadge style={{ marginTop: "2px", color: '#d83904' }} size={15} onClick={menuIconClick} /> },
                      { type: "link", to: "", onClick: showModalCustomerGroups, text: "گروه مشتری", code: 8, icon: <Diagram3Fill style={{ marginTop: "2px", color: 'blue' }} size={17} onClick={menuIconClick} /> },
                      { type: "link", to: "/CRM/AddEditCustomer/0", onClick: closeMenu, text: "مشتری جدید", code: 16, icon: <PersonPlus style={{ marginTop: "2px", color: '#0b8e95' }} size={17} onClick={menuIconClick} /> },
                      { type: "link", to: "/CRM/SearchCustomer", onClick: closeMenu, text: "جستجوی مشتریان", code: 32, icon: <Search style={{ marginTop: "2px", color: 'violate' }} size={15} onClick={menuIconClick} /> },
                      { type: "link", to: "", onClick: showModalPerson, text: "جستجوی پیشرفته", code: 64, icon: <Search style={{ marginTop: "2px", color: 'blue' }} size={15} onClick={menuIconClick} /> },
                      { type: "link", to: "", onClick: () => showModalImportExl("customer"), text: "دریافت از اکسل", code: 128, icon: <FileEarmarkExcelFill style={{ marginTop: "2px", color: '#00804e' }} size={15} onClick={menuIconClick} /> }
                    ]
                  },
                  {
                    type: "menuItem", title: "مشتریان بالقوه", subItems: [
                      { type: "link", to: "/CRM/ModalPreCustomerStatus", onClick: closeMenu, text: "وضعیت مشتری", code: 256, icon: <PersonBadge style={{ marginTop: "2px", color: '#d83904' }} size={15} onClick={menuIconClick} /> },
                      { type: "link", to: "/CRM/AddEditPreCustomer/0", onClick: closeMenu, text: "مشتری جدید", code: 512, icon: <PersonPlus style={{ marginTop: "2px", color: '#0b8e95' }} size={17} onClick={menuIconClick} /> },
                      { type: "link", to: "/CRM/SearchPreCustomer", onClick: closeMenu, text: "جستجوی مشتریان", code: 1024, icon: <Search style={{ marginTop: "2px", color: 'violate' }} size={15} onClick={menuIconClick} /> },
                      { type: "link", to: "", onClick: showModalSaleComps, text: "رقبای فروش", code: 2048, icon: <PersonRolodex style={{ marginTop: "2px", color: 'blue' }} size={17} onClick={menuIconClick} /> },
                      { type: "link", to: "", onClick: () => showModalImportExl("precustomer"), text: "دریافت از اکسل", code: 4096, icon: <FileEarmarkExcelFill style={{ marginTop: "2px", color: '#00804e' }} size={15} onClick={menuIconClick} /> }
                    ]
                  },
                  {
                    type: "menuItem", title: "کمپین فروش", subItems: [
                      { type: "link", to: "/CRM/AddEditSaleCampaign/0", onClick: closeMenu, text: "تعریف/ویرایش", code: 8192, icon: <PersonBadge style={{ marginTop: "2px", color: '#d83904' }} size={15} onClick={menuIconClick} /> }
                    ]
                  },
                  {
                    type: "menuItem", title: "تیکت های پشتیبانی", subItems: [
                      { type: "link", to: "/CRM/Ticket", onClick: closeMenu, text: "تیکت های ثبت شده", code: 16384, icon: <ChatRightText style={{ marginTop: "2px", color: 'blue' }} size={15} onClick={menuIconClick} /> },
                    ]
                  },
                  {
                    type: "menuItem", title: "رضایت سنجی", subItems: [
                      { type: "link", to: "/CRM/HappyCallSettings", onClick: closeMenu, text: "تنظیم و راه اندازی", code: 32768, icon: <Gear style={{ marginTop: "2px", color: 'blue' }} size={15} onClick={menuIconClick} /> },
                      { type: "link", to: "/CRM/HappyCallServiceList", onClick: closeMenu, text: "سرویس های رضایت سنجی", code: 65536, icon: <Headset style={{ marginTop: "2px", color: 'purple' }} size={15} onClick={menuIconClick} /> },
                    ]
                  },
                  {
                    type: "menuItem", title: "شکایات", subItems: [
                      { type: "link", to: "/CRM/Complaint/0/0/0", onClick: closeMenu, text: "ثبت شکایت", code: 131072, icon: <EmojiAngry style={{ marginTop: "2px", color: '#c80d42' }} size={15} onClick={menuIconClick} /> },
                      { type: "link", to: "/CRM/SearchComplaints", onClick: closeMenu, text: "جستجوی شکایت", code: 262144, icon: <Search style={{ marginTop: "2px", color: '#c80d42' }} size={15} onClick={menuIconClick} /> },
                      { type: "link", to: "", onClick: showModalComplaintsGroup, text: "گروهبندی شکایات", code: 524288, icon: <BoundingBox style={{ marginTop: "2px", color: 'blue' }} size={15} onClick={menuIconClick} /> },
                      { type: "link", to: "", onClick: showModalComplaintsStatus, text: "مدیریت وضعیت شکایات", code: 1048576, icon: <Speedometer style={{ marginTop: "2px", color: '#00805d' }} size={15} onClick={menuIconClick} /> },
                      { type: "link", to: "", onClick: showModalCompType, text: "مدیریت انواع شکایت", code: 2097152, icon: <LayoutWtf style={{ marginTop: "2px", color: 'purple' }} size={15} onClick={menuIconClick} /> },
                      { type: "link", to: "", onClick: showModalCompTarget, text: "مدیریت بخش های مورد شکایت", code: 4194304, icon: <Columns style={{ marginTop: "2px", color: '#151784' }} size={15} onClick={menuIconClick} /> }
                    ]
                  },
                  {
                    type: "menuItem", title: "گزارش ها", subItems: [
                      { type: "link", to: "/CRM/EventsHistory", showCondition: () => checkModule(appModules, systemModules.EventsManagement), onClick: closeMenu, text: "تاریخچه رویدادها", code: 8388608, icon: <CalendarEventFill size={15} onClick={menuIconClick} /> },
                      { type: "link", to: "/CRM/CallHistory", showCondition: () => checkModule(appModules, systemModules.EventsManagement), onClick: closeMenu, text: "تاریخچه تماس ها", code: 16777216, icon: <CalendarEventFill color="green" size={15} onClick={menuIconClick} /> },
                      { type: "link", to: "/CRM/CallDashboard", showCondition: () => checkModule(appModules, systemModules.EventsManagement), onClick: closeMenu, text: "داشبورد تماس ها", code: 268435456, icon: <Calendar2Event color="green" size={15} onClick={menuIconClick} /> },
                      { type: "link", to: "/CRM/HappycallGrades", onClick: closeMenu, text: "گزارش عملکرد(رضایت سنجی)‏", code: 33554432, icon: <Clipboard2Data style={{ marginTop: "2px", color: 'purple' }} size={15} onClick={menuIconClick} /> },
                      { type: "link", to: "/CRM/CustomersHappycallGrades", onClick: closeMenu, text: "گزارش سطح رضایت مشتریان", code: 67108864, icon: <Clipboard2DataFill style={{ marginTop: "2px", color: 'blue' }} size={15} onClick={menuIconClick} /> },
                      { type: "link", to: "/CRM/HappycallVarianceList", onClick: closeMenu, text: "گزارش کنترل دریافتی", code: 134217728, icon: <Clipboard2Data style={{ marginTop: "2px", color: 'green' }} size={15} onClick={menuIconClick} /> },
                    ]
                  }
                ]}

              />}
            {
              checkModule(appModules, systemModules.Commands) &&
              <MenuItem title="دستور کار" subsysCode={256} items={[
                { type: "link", to: "/SearchCommands", onClick: closeMenu, text: "جستجوی دستور کار", code: 2, icon: <Command style={{ color: "seagreen" }} onClick={menuIconClick} /> },
                { type: "link", to: "", onClick: showCommand, text: "دستور کار جدید", code: 4, icon: <ChatRight style={{ color: 'red' }} onClick={menuIconClick} /> }
              ]}
              />}
            {checkModule(appModules, systemModules.SMSManagement) &&
              <MenuItem title="پیامک ها" subsysCode={512} items={[
                { type: "link", to: "", onClick: showModalSMS, text: "ارسال پیامک", code: 2, icon: <Envelope style={{ marginTop: "2px", color: "red" }} size={15} onClick={menuIconClick} /> },
                { type: "link", to: "/SMSTemplates", onClick: closeMenu, text: "قالب پیامک", code: 4, icon: <Fragment> <EnvelopeFill style={{ marginTop: "2px", color: "blue" }} size={15} onClick={menuIconClick} /></Fragment> },
                { type: "link", to: "/SearchSentSMS", onClick: closeMenu, text: "جستجوی  پیامکهای ارسالی", code: 8, icon: <Search style={{ marginTop: "2px", color: "red" }} size={15} onClick={menuIconClick} /> },
                { type: "link", to: "/SearchReceivedSMS", onClick: closeMenu, text: "جستجوی  پیامکهای دریافتی", code: 16, icon: <Search style={{ marginTop: "2px", color: "green" }} size={15} onClick={menuIconClick} /> }
              ]} />
            }
            {checkModule(appModules, systemModules.Reminders) &&
              <MenuItem title="یادآوری ها" subsysCode={1024} items={[
                { type: "link", to: "", onClick: showReminderModal, text: "یادآوری جدید", code: 2, icon: <Calendar2Date style={{ marginTop: "2px", color: '#0b8e95' }} size={15} /> },
                { type: "link", to: "", onClick: showSearchReminders, text: "جستجوی یادآوری ها", code: 4, icon: <CalendarDate style={{ marginTop: "2px", color: 'violate' }} size={15} /> }
              ]} />
            }
            <MenuItem title="مدیریت سیستم" subsysCode={2048} items={[

              { type: "link", to: "/UserDashboard", onClick: closeMenu, text: "کارتابل کاربر", code: 2, icon: <PersonBadge style={{ marginTop: "2px", color: 'blue' }} size={15} /> },
              { type: "link", to: "", onClick: releaseNet, text: "آزاد سازی شبکه", code: 4, icon: <HddNetwork style={{ marginTop: "2px", color: '#0b8e95' }} size={15} /> },
              { type: "link", to: "", onClick: activeSoftware, text: "فعال سازی نرم افزار", code: 8, icon: <ShieldCheck style={{ marginTop: "2px", color: 'red' }} size={15} /> },
              { type: "link", to: "", onClick: showModalDuration, text: "دوره های مالی", code: 16, icon: <Calendar2 style={{ marginTop: "2px", color: 'blue' }} size={15} /> },
              { type: "link", to: "/Contacts", onClick: closeMenu, text: "مخاطبین", code: 32, icon: <PersonBadge style={{ marginTop: "2px", color: 'green' }} size={15} /> },
            ]} />
            <MenuItem title="تماس با ما" items={[
              { type: "a", href: company?.AboutUS, onClick: closeMenu, text: "درباره ما", icon: <InfoSquare style={{ marginTop: "2px", color: '#0b8e95' }} size={15} /> },
              { type: "a", href: company?.ContactUS, onClick: closeMenu, text: "تماس با ما", icon: <Phone style={{ marginTop: "2px", color: 'red' }} size={15} /> },
              { type: "a", href: company?.WebSite, onClick: closeMenu, text: "وب سایت شرکت", icon: <Globe style={{ marginTop: "2px", color: 'blue' }} size={15} /> },
              { type: "a", href: company?.NewsURL, onClick: closeMenu, text: "خبرها", icon: <Newspaper style={{ marginTop: "2px", color: 'brown' }} size={15} /> }
            ]} />
          </div>
          <div className="footer" >
            <InfoSquare size={20} style={{ cursor: "pointer" }} color={"rgb(115, 57, 141)"} onClick={() => setModalAboutUs(true)} />
            <p style={{ marginTop: "4px" }} id="MenuPoweredByBihamta"></p>
            <p id="MenuPoweredByHoormah"></p>
            <p >شماره نسخه: {pkg.version}</p>
          </div>

        </div>
      </Fragment> : null)
}
export default MenuWide;
